<div  class="work-container">
	<div class="contact-form">
		<div class="work-title highlight">Get in Touch</div>

		<div class="confirmation-message" *ngIf="!showForm">
			Thank you for your reponse! We will reach out to you shortly.
		</div>
		<form id="demo-form" *ngIf="showForm">

			<div class="input-field-row">
				<div class="input-field-container">
					<div class="input-label"><span class="label-text">First Name*</span></div>
					<input class="input-area" type="text" [(ngModel)]="firstname" name="firstname">
				</div>

				<div class="input-field-container">
					<div class="input-label"><span class="label-text">Last Name*</span></div>
					<input class="input-area" type="text" [(ngModel)]="lastname" name="lastname">
				</div>
			</div>
			
			<div class="input-field-row">
				<div class="input-field-container">
					<div class="input-label"><span class="label-text">E-mail*</span></div>
					<input class="input-area" type="email" [(ngModel)]="email" name="email">
				</div>

				<!-- <div class="input-field-container">
					<div class="input-label"><span class="label-text">What is the best phone number to reach you at?</span></div>
					<input class="input-area" type="tel" [(ngModel)]="phone" name="phone" 
					pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" 
					required>
				</div> -->

				<div class="input-field-container">
					<div class="input-label"><span class="label-text">Number of People* <span class="small">(Groups less than 10: join us at our next monthly pop up!)</span></span></div>
					<input class="input-area" type="number" [(ngModel)]="numberpeople" name="numberpeople">
				</div>
			</div>

			<div class="input-field-row">
				

				<div class="input-field-container">
					<div class="input-label"><span class="label-text">Desired Date* <span class="small">(Minimum 3 week lead time)</span></span></div>
					<input class="input-area" type="date" [(ngModel)]="date" name="date" min="{{getMinDate()}}">
				</div>

				<div class="input-field-container">
					<div class="input-label"><span class="label-text">Desired Time</span></div>
					<input class="input-area" type="text" [(ngModel)]="time" name="time">
				</div>
			</div>

			<div class="input-field-row">
				

				<div class="input-field-container">
					<div class="input-label"><span class="label-text">Where will your event be located?*</span></div>
					<input class="input-area" type="text" [(ngModel)]="location" name="location">
				</div>

				<div class="input-field-container">
					<div class="input-label"><span class="label-text">How did you hear about us?</span></div>
					<input class="input-area" type="text" [(ngModel)]="referral" name="referral">
				</div>
			</div>

			 

			<div class="input-field-row">
				<div class="input-field-container">
					<div *ngIf="captchaToken!='' 
					&& email!='' 
					&& numberpeople!='' 
					&& date != ''" class="button" (click)="submitForm($event)">Submit</div>
				</div>
			</div>

			<re-captcha
			    (resolved)="onCaptchaResolved($event)"
			    [siteKey]="siteKey">
			  </re-captcha>

		</form>

		


	</div>
		
</div>

